import { render, staticRenderFns } from "./ProductPrescriptionCreate.vue?vue&type=template&id=2f3ef45c&"
import script from "./ProductPrescriptionCreate.vue?vue&type=script&lang=js&"
export * from "./ProductPrescriptionCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports